import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ListVpsByStatusPage from "../ListVpsByStatusPage";

const AdminListVpsByStatusPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectChangeUser = (listVpsId) => {
        navigate('/admin/vps/chuyen-khach-hang.html?' + listVpsId);
    }

    let redirectExportExcel = (listVps) => {
        navigate('/admin/vps/xuat-file-excel.html?' + listVps);
    }

    return <ListVpsByStatusPage
        statusParams={ params.status }
        redirectChangeUser={ (listVpsId) => redirectChangeUser(listVpsId) }
        redirectExportExcel={ (listVps) => redirectExportExcel(listVps) }
    />

}

export default AdminListVpsByStatusPage;